import { type FC } from "react"
import { Navigate, useParams } from "react-router"

import { parseNumber } from "@forento/shared/utilities/number"

import { useDownloadable } from "~/api/downloadable"
import Button from "~/themes/school/components/Button"
import Layout from "~/themes/school/components/Layout"
import PartialLoadingPage from "~/themes/school/components/PartialLoadingPage"
import ProductDetail from "~/themes/school/components/ProductDetail"
import { useTranslation } from "~/translations"
import routes from "~/utilities/routes"

const DownloadablePage: FC = () => {
	const downloadableId = parseNumber(useParams().downloadableId) ?? -1
	const t = useTranslation()

	const downloadable = useDownloadable(downloadableId)

	if (downloadable.status === "not-found") return <Navigate to={routes.downloadable.index()} />

	return (
		<Layout>
			{downloadable.status === "error" ? (
				<p>{t("failedToLoad")}</p>
			) : downloadable.status === "loading" ? (
				<PartialLoadingPage />
			) : (
				<ProductDetail
					type="downloadable"
					product={downloadable}
					unlockedContent={
						<Button
							variant="primary"
							onClick={downloadable.download}
							isLoading={downloadable.downloadProgress !== undefined}
						>
							{downloadable.downloadProgress === undefined
								? t("general.download")
								: t("downloadable.downloading", {
										progress: Math.floor(downloadable.downloadProgress * 100),
									})}
						</Button>
					}
					reload={downloadable.reload}
				/>
			)}
		</Layout>
	)
}

export default DownloadablePage
